import type { ComponentProps } from 'yet-another-react-lightbox';
import {
  createModule,
  type PluginProps,
  useLightboxDispatch,
  useLightboxState,
} from 'yet-another-react-lightbox';

function KeepIndexModule({ children, open }: ComponentProps) {
  const { currentIndex, slides } = useLightboxState();
  const dispatch = useLightboxDispatch();

  useEffect(() => {
    if (!open) return;
    if (currentIndex < slides.length) return;
    dispatch({ type: 'swipe', increment: -(currentIndex - (slides.length - 1)) });
  }, [currentIndex, slides, dispatch, open]);

  //   const viewedSlideKeyRef = useRef<{ key: string; index: number } | null>(null);
  //   useEffect(() => {
  //     if (!slides?.length) {
  //       viewedSlideKeyRef.current = null;
  //       return;
  //     }

  //     const oldRef = viewedSlideKeyRef.current;
  //     const currentSlide = slides[currentIndex];

  //     if (oldRef != null && currentSlide.key === oldRef.key) {
  //       const newIndex = slides.findIndex((s) => s.key === currentSlide.key);
  //       if (newIndex !== oldRef.index) {
  //         dispatch({ type: 'update', slides, index: newIndex });
  //         viewedSlideKeyRef.current = { key: oldRef.key, index: newIndex };
  //         return;
  //       }
  //     }

  //     viewedSlideKeyRef.current = { key: currentSlide.key, index: currentIndex };
  //   }, [slides, currentIndex, dispatch]);
  //   useEffect(() => {
  //     if (open) return;
  //     viewedSlideKeyRef.current = null;
  //   }, [open]);

  //   const viewedSlideKeyRef = useRef<string | null>(null);

  //   useEffect(() => {
  //     if (!slides?.length) return;

  //     const inBounds = currentIndex < slides.length;
  //     if (inBounds) {
  //       viewedSlideKeyRef.current = slides[currentIndex]?.key ?? null;
  //     }
  //     const viewedKey = viewedSlideKeyRef.current;
  //     const newIndexByKey = viewedKey != null ? slides.findIndex((s) => s.key === viewedKey) : -1;

  //     if (newIndexByKey >= 0 && newIndexByKey !== currentIndex) {
  //       dispatch({ type: 'update', slides, index: newIndexByKey });
  //       viewedSlideKeyRef.current = slides[newIndexByKey]?.key ?? null;
  //     } else if (currentIndex >= slides.length) {
  //       const clamped = slides.length - 1;
  //       dispatch({ type: 'update', slides, index: clamped });
  //       viewedSlideKeyRef.current = slides[clamped]?.key ?? null;
  //     }
  //   }, [slides, currentIndex, dispatch]);

  return children;
}

export function KeepIndex({ addModule }: PluginProps) {
  addModule(createModule('KEEP_INDEX', KeepIndexModule));
}
